var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8049 14.106H14.8249M14.8049 6.10596H24.8049C25.8287 6.10593 26.8523 6.49645 27.6334 7.27753L41.6335 21.2775C43.1956 22.8396 43.1956 25.3723 41.6335 26.9344L27.6334 40.9344C26.0713 42.4965 23.5386 42.4965 21.9765 40.9344L7.9765 26.9344C7.19546 26.1533 6.80493 25.1296 6.80493 24.106V14.106C6.80493 9.68768 10.3867 6.10596 14.8049 6.10596Z",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.3f3b2a037bbc38643d7e2fb88897854c.svg";
export { ForwardRef as ReactComponent };